import React, { Component } from 'react'
import TableComp from '../../../../components/_utils/table'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'

import { Link } from "react-router-dom";
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import moment from 'moment'
import { Button, Card, Col, Form, Drawer, Icon, notification, Switch, Popconfirm, Row, Select, Tooltip } from 'antd'
import Request, { API_URL, LAPI_URL, MEDIA_URL } from '../../../../request'
import _ from 'lodash'
import { connect } from 'react-redux'
import styles from '../../country/all/styles.less'
import common from '../../../common.less'
import setting from '../../../../components/_utils/settings'
import rightAuth from '../../../../components/_utils/userRights'
import { RightsWrapper } from '../../../../components/_utils/utils'
import PDFFileView from '../../../../components/DocumentViews/PDFFileView'
const Option = Select.Option

@Form.create()
class AllPartner extends Component {
  state = {
    visible: false,
    count: 0,
    dataToShow: [],
    exportLoading: false,
    partnerArr: [],
    channelPartnerId: "",
    countryArr: [],
    countryId: "",
    ext: null,
    agreement: [],
    linkUrl: null,
    campusUniversityId: "",
    preferredPartnerOptions: [
      { value: true, label: "Yes" },
      { value: false, label: "No" }
    ],
    uniArr: [],
    active: true
  };
  exportExcel = async () => {
    const { exportParams } = this.state;

    this.setState({ exportLoading: true });
    let x = await Request.exportChannelPartnersToExcel({
      ...exportParams,
      regExFilters: ["channelPartnerName"],
    });
    this.setState({ exportLoading: false });

    if (!x.error) {
      window.open(x.url);
    }
  };
  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
      dataToShow: [],
    });
  };

  changeEmployeeIncentive = async ({ checked, _id }) => {
    await Request.changeEmployeeIncentive({ _id: _id._id, employeeIncentive: checked })
    this.table.current.reload();
  }

  changeChannelPartnerStatus = async ({ checked, _id }) => {
    let response = await Request.changeChannelPartnerStatus({ _id, active: checked });
    if (response.success) {
      notification.success({
        message: response.message
      });
    } else {
      notification.error({
        message: response.message
      });
    }
    this.table.current.reload();
  }

  apiRequest = (params) => {
    return new Promise(async (resolve) => {
      this.setState({ exportParams: params });

      if (this.state.channelPartnerId) {
        params._id = this.state.channelPartnerId;
      }

      if (this.state.countryId) {
        params.channelCountryId = this.state.countryId;
      }

      if (this.state.campusUniversityId) {
        params.uniArr = this.state.campusUniversityId;
      }

      if (this.state.preferredPartner) {
        params.preferredPartner = this.state.preferredPartner;
      }

      params.active = this.state.active;

      let data = await Request.getPartners({
        ...params,
        regExFilters: ["channelPartnerName"],
      });
      this.setState({ count: data.total });
      resolve(data);
    });
  };

  loadChannelPartners = async () => {
    let arr = await Request.loadChannelPartners({
      results: 10000,
    });
    this.setState({ partnerArr: arr.data });
  };

  loadCountries = async () => {
    let countriesList = await Request.getCountries({
      results: 10000,
    });
    this.setState({ countryArr: countriesList.data });
  };

  onPartnerChoose = (v) => {
    this.setState({ channelPartnerId: v }, () => {
      this.table.current.reload();
    });
  };

  onCountryChoose = (v) => {
    this.setState({ countryId: v }, () => {
      this.table.current.reload();
    });
  };

  loadUni = async () => {
    let arr = await Request.loadSimpleUniversities();
    this.setState({ uniArr: arr.arr });
  };
  onUniChoose = (v) => {
    this.setState({ campusUniversityId: v }, () => {
      this.table.current.reload();
    });
  };

  handleSubmit = e => {
    const { dispatch, form } = this.props
    e.preventDefault()

    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {

        let values = _.clone(valData)

        let x = null
        x = await Request.addChannelPartnerExcelData(values)

        if (!x.error) {
          notification.success({
            message: x.message
          })

          this.setState({ visible1: false })
          this.table.current.reload()
        } else {
          notification.error({
            message: x.message

          })
        }
      }
    })
  }

  handleDelete = (val) => {
    Request.deleteChannelPartner({ id: val })
      .then((x) => {
        if (x.success) {
          notification.success({
            message: x.msg,
            description: x.msg,
          });
        } else {
          notification.error({
            message: "Error",
            description: x.msg,
          });
        }
        this.table.current.reload();
      })
      .catch((err) => {
        notification.error({
          message: "Error",
          description: "Some Error",
        });
      });
  };

  viewCommPDF = e => {
    const { paymentUploadCommissionPage } = e;
    // const { form, serviceData, partnershipArr } = this.props;
    // const { agreement } = serviceData;
    if (paymentUploadCommissionPage.length > 0) {
      let linkUrl = MEDIA_URL + paymentUploadCommissionPage[0].url;
      let ext = linkUrl ? this.checkUrlExt(linkUrl) : null;
      if (this.checkUrlExt(linkUrl)) {
        this.setState({ ext: ext, linkUrl: linkUrl, agreement: paymentUploadCommissionPage });
      } else {
        notification.warning({
          message: 'Agreement not exists!!!.'
        })
      }
    }
  }
  viewPDF = e => {
    const { paymentUpload } = e;
    // const { form, serviceData, partnershipArr } = this.props;
    // const { agreement } = serviceData;
    if (paymentUpload.length > 0) {
      let linkUrl = MEDIA_URL + paymentUpload[0].url;
      let ext = linkUrl ? this.checkUrlExt(linkUrl) : null;
      if (this.checkUrlExt(linkUrl)) {
        this.setState({ ext: ext, linkUrl: linkUrl, agreement: paymentUpload });
      } else {
        notification.warning({
          message: 'Agreement not exists!!!.'
        })
      }
    }
  }

  checkUrlExt = (url) => {
    return url.split(/[#?]/)[0].split('.').pop().trim();
  }

  closeDocument = () => {
    this.setState({ ext: null, linkUrl: null, agreement: [] });
  }

  constructor(props) {
    super(props);
    this.table = React.createRef();

    this.loadChannelPartners();
    this.loadCountries();
    this.loadUni();
  }

  componentDidMount() { }

  render() {
    const { visible, dataToShow, preferredPartnerOptions, ext, linkUrl, agreement } = this.state;
    const inputTypes = {
      fields: [
        { label: 'Choose Excel File', key: 'excelFile', type: 'file', required: true }
      ]
    }
    const {
      form: { getFieldDecorator, getFieldValue }
    } = this.props
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
        md: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
        md: { span: 12 }
      }
    }

    const columns = [
      {
        title: "Partner Name",
        key: "channelPartnerName",
        dataIndex: "channelPartnerName",
        width: 270,
        searchTextName: "channelPartnerName",
        filterRegex: true,
        render: (val, record) => {
          return <React.Fragment>
            {rightAuth.checkRights("ChannelPartner.edit") ? <RightsWrapper myRight={"ChannelPartner.edit"}>
              <Tooltip title="Click To Edit Details">
                <a href={`/master/edit-partner?id=${record._id}`}>
                  {val} - {record.universities.length}
                </a>
              </Tooltip>
            </RightsWrapper> : <React.Fragment>
              {val} - {record.universities.length}
            </React.Fragment>}
          </React.Fragment>;
        },
      },
      {
        title: "Address",
        width: 290,
        key: "channelAddress",
        dataIndex: "channelAddress",
      },
      {
        title: "Preferred Partner",
        width: 110,
        key: "preferredPartner",
        dataIndex: "preferredPartner",
        filters:
          preferredPartnerOptions &&
          preferredPartnerOptions.map((x) => ({
            value: x.value,
            text: x.label,
          })),
        render: (val, row) => {
          return <div>{row.preferredPartner ? "Yes" : "No"}</div>;
        },
      },
      {
        title: "Country",
        width: 90,
        key: "countryName",
        dataIndex: "countryName",
        render: (val, row) => {
          return (
            <div>
              {row.channelCountryId ? row.channelCountryId.countryName : null}
            </div>
          );
        },
      },
      {
        title: 'Agent Code',
        width: 90,
        key: 'agentCode',
        dataIndex: 'agentCode'
      },
      {
        title: "University",
        key: "university",
        width: 250,
        render: (val, row) => {
          let moreCamp = 0;
          if (row.universities) {
            moreCamp = row.universities.length - 2;
          }
          return (
            <div>
              <ul className={common.sl}>
                {row.universities.map((val, inde) => {
                  return val.universityName && inde < 2 ? (
                    <li key={inde}>
                      <Icon type={"check"} /> {val.universityName}
                    </li>
                  ) : null;
                })}
                <li />
              </ul>

              {moreCamp > 0 ? (
                <button

                  onClick={() => {
                    this.setState({
                      dataToShow: row.universities,
                      visible: true,
                    });

                    this.setState({
                      dataToShow: row.universities,
                      visible: true,
                    });
                  }}
                >
                  {moreCamp} more
                </button>
              ) : null}
            </div>
          );
        },
      },
      {
        title: "Employee Incentive",
        width: 80,
        key: 'employeeIncentive',
        dataIndex: 'employeeIncentive',
        render: (text, record) => {
          return (
            <div>
              <Switch checked={record.employeeIncentive} onChange={(checked) => {
                this.changeEmployeeIncentive({ checked, _id: record._id })
              }} />
            </div>
          )
        }
      },
      {
        title: 'Agreement',
        key: 'paymentUpload',
        width: 90,
        render: (text, record) => (
          record.paymentUpload && record.paymentUpload.length > 0 ? <Button type='primary' icon='eye' onClick={() => this.viewPDF(record)} /> : "N/A"
        )
      },
      {
        title: 'Agreement Commission Page',
        key: 'paymentUploadCommissionPage',
        width: 120,
        render: (text, record) => (
          record.paymentUploadCommissionPage && record.paymentUploadCommissionPage.length > 0 ? <Button type='primary' icon='eye' onClick={() => this.viewCommPDF(record)} /> : "N/A"
        )
      },
      {
        title: "Updated By",
        width: 150,
        key: "updatedByUser",
        dataIndex: "updatedByUser",
        render: (text, record) => {
          return (
            <div>
              <div className={common.user}>{text ? text.name : ""} </div>
              <small>
                {text ? moment(text.time).format(setting.masterFormat) : ""}
              </small>
            </div>
          );
        },
      },
      {
        title: "Created By",
        width: 150,
        key: "createdByUser",
        dataIndex: "createdByUser",
        render: (text, record) => {
          return (
            <div>
              <div className={common.user}>{text ? text.name : ""} </div>
              <small>
                {text ? moment(text.time).format(setting.masterFormat) : ""}
              </small>
            </div>
          );
        },
      },
      {
        title: "Action",
        key: "operation",
        width: 120,
        render: (text, record) => (

          < React.Fragment >
            <Tooltip title="Delete Channel Partner">
              <Popconfirm
                title="Are you sure to delete Channel Partner?"
                onConfirm={() => this.handleDelete(record._id._id)}
                okText="Yes"
                cancelText="No"
              >
                <Button shape="circle" className={styles.btn} icon="delete" />
              </Popconfirm>
            </Tooltip>
            <Switch size='small' checked={record.active} onChange={(checked) => {
              this.changeChannelPartnerStatus({ checked, _id: record._id })
            }} />
          </React.Fragment >
        ),
      },
    ];
    return (
      <PageHeaderWrapper title={`Total Channel Partners : ${this.state.count}`}>
        {
          ext != null && agreement.length > 0 ?
            <PDFFileView linkUrl={linkUrl} ext={ext} onClose={this.closeDocument} />
            : null
        }
        <Card >
          <Row style={{ marginBottom: '1rem' }}>
            <Col span={7} >
              <h4>SEARCH BY PARTNER</h4>
              <Select
                showSearch
                allowClear
                style={{ width: '14rem' }}
                value={this.state.channelPartnerId}
                placeholder="Select"
                optionFilterProp="channelPartnerName"
                onChange={this.onPartnerChoose}
                filterOption={(input, option) => {
                  return (
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
              >
                {this.state.partnerArr.map((val, idn) => {
                  return (
                    <Option key={idn} value={val._id}>
                      {val.channelPartnerName}
                    </Option>
                  );
                })}
              </Select>
            </Col>
            <Col span={7} style={{ margin: '0rem 1rem' }}>
              <h4>SEARCH BY COUNTRY</h4>
              <Select
                showSearch
                allowClear
                style={{ width: '14rem' }}
                value={this.state.countryId}
                placeholder="Select Country"
                optionFilterProp="countryName"
                onChange={this.onCountryChoose}
                filterOption={(input, option) => {
                  return (
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
              >
                {this.state.countryArr.map((val, idn) => {
                  return (
                    <Option key={idn} value={val._id}>
                      {val.countryName}
                    </Option>
                  );
                })}
              </Select>
            </Col>
            <Col span={7}>
              <h4>SEARCH BY UNIVERSITY</h4>
              <Select
                showSearch
                allowClear
                style={{ width: '18rem' }}
                value={this.state.campusUniversityId}
                placeholder="Select University"
                optionFilterProp="universityInstitutionName"
                onChange={this.onUniChoose}
                filterOption={(input, option) => {
                  return (
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
              >
                {this.state.uniArr.map((val, idn) => {
                  return (
                    <Option key={idn} value={val._id}>
                      {val.universityInstitutionName}
                    </Option>
                  );
                })}
              </Select>
            </Col>
          </Row>
          <Row style={{ display: 'flex' }}>
            <Col style={{ marginRight: '1rem' }} >
              {
                rightAuth.checkRights("ChannelPartnerExcelExport.view") ?
                  <Button
                    type={"default"}
                    loading={this.state.exportLoading}
                    onClick={() => {
                      this.exportExcel();
                    }}
                  >
                    Export Excel
                  </Button>
                  : null
              }
            </Col>
            <Col style={{ marginRight: '1rem' }} >
              <Button
                type={'primary'}

                onClick={() => { this.setState({ visible1: true }) }}
              >Add Excel File</Button>
            </Col>
            <Col style={{ marginRight: '1rem' }} >
              <div >
                <Link to='/master/add-partner'><Button>Add</Button></Link>
              </div>
            </Col>
            <Col style={{ marginRight: '1rem' }} >
              <Button
                type={'primary'}

                onClick={() => { this.setState({ active: !this.state.active }, () => this.table.current.reload()) }}
              >Show {this.state.active ? "InActive" : "Active"} Partners</Button>
            </Col>

          </Row>
        </Card>
        <Card bordered={true}>
          <TableComp
            ref={this.table}
            columns={columns}
            apiRequest={this.apiRequest}
            extraProps={{ scroll: { x: 1400 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 20,
              pageSizeOptions: ["10", "20", "50", "100", "1000"],
            }}
          />

          <Drawer
            title={`All Universities:- ${dataToShow.length}`}
            placement="right"
            closable={true}
            onClose={this.onClose}
            visible={visible}
            width={600}
          >
            <div className={styles.drawerWrapper}>
              <Button
                type={"danger"}
                onClick={this.onClose}
                style={{ marginTop: 20, marginLeft: 8 }}
              >
                Close
              </Button>

              <ul className={common.sl} style={{ marginTop: 40 }}>
                {dataToShow.map((val, inde) => {
                  return val.universityName ? (
                    <li key={inde}>
                      <Icon type={"check"} /> {val.universityName}
                    </li>
                  ) : (
                    <span key={inde} />
                  );
                })}
                <li />
              </ul>
            </div>
          </Drawer>
        </Card>

        {
          this.state.visible1 && <Drawer
            title=""
            placement="right"
            closable={true}
            onClose={() => {
              this.setState({
                visible1: false
              })
            }}
            visible={this.state.visible1}
            width={500}>
            <div>
              <Card bordered={true}>
                <div>

                  <Form onSubmit={this.handleSubmit} {...formItemLayout} style={{ marginTop: 8 }}>
                    <GetAllFormFields apiurl={LAPI_URL}
                      inputSchema={inputTypes}
                      getFieldDecorator={getFieldDecorator} />

                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ marginLeft: '10%' }}
                      loading={this.state.loading}>
                      UPLOAD

                    </Button>

                    <a href={'../../../importChannelPartner.xlsx'} download={'sample.xlsx'}>
                      <Button
                        type="default"
                        style={{ marginLeft: '10%' }}
                        loading={this.state.loading}>
                        DOWNLOAD SAMPLE FILE
                      </Button>
                    </a>
                  </Form>

                </div>


              </Card>
            </div>
          </Drawer>
        }
      </PageHeaderWrapper >
    );
  }
}

const mapStateToProps = ({ global }) => ({
  categories: global.categories
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllPartner)